var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.32422 14.0002C3.32422 8.96851 3.32422 6.45269 4.88735 4.88955C6.45049 3.32642 8.96632 3.32642 13.998 3.32642C19.0296 3.32642 21.5455 3.32642 23.1086 4.88955C24.6717 6.45269 24.6717 8.96851 24.6717 14.0002C24.6717 19.0318 24.6717 21.5477 23.1086 23.1108C21.5455 24.6739 19.0296 24.6739 13.998 24.6739C8.96632 24.6739 6.45049 24.6739 4.88735 23.1108C3.32422 21.5477 3.32422 19.0318 3.32422 14.0002Z",
    fill: "url(#paint0_linear_5178_10837)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8415 8.3823C14.8415 7.9169 14.4642 7.53963 13.9988 7.53963C13.5335 7.53963 13.1562 7.9169 13.1562 8.3823V19.6178C13.1562 20.0832 13.5335 20.4605 13.9988 20.4605C14.4642 20.4605 14.8415 20.0832 14.8415 19.6178V8.3823Z",
    fill: "url(#paint1_linear_5178_10837)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22374 15.1236C9.22374 14.6582 8.84647 14.2809 8.38108 14.2809C7.91568 14.2809 7.53841 14.6582 7.53841 15.1236V19.6178C7.53841 20.0832 7.91568 20.4605 8.38108 20.4605C8.84647 20.4605 9.22374 20.0832 9.22374 19.6178V15.1236Z",
    fill: "url(#paint2_linear_5178_10837)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6166 12.0338C20.082 12.0338 20.4593 12.4111 20.4593 12.8765V19.6178C20.4593 20.0832 20.082 20.4605 19.6166 20.4605C19.1512 20.4605 18.7739 20.0832 18.7739 19.6178V12.8765C18.7739 12.4111 19.1512 12.0338 19.6166 12.0338Z",
    fill: "url(#paint3_linear_5178_10837)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0631 2.48364H13.9346C11.4732 2.48363 9.53995 2.48362 8.03055 2.68655C6.48381 2.8945 5.2566 3.32936 4.29237 4.29359C3.32814 5.25782 2.89328 6.48503 2.68533 8.03177C2.4824 9.54117 2.48241 11.4744 2.48242 13.9358V14.0643C2.48241 16.5257 2.4824 18.4589 2.68533 19.9683C2.89328 21.5151 3.32814 22.7423 4.29237 23.7065C5.2566 24.6708 6.48381 25.1056 8.03055 25.3136C9.53995 25.5165 11.4732 25.5165 13.9346 25.5165H14.0631C16.5244 25.5165 18.4577 25.5165 19.9671 25.3136C21.5139 25.1056 22.7411 24.6708 23.7053 23.7065C24.6695 22.7423 25.1044 21.5151 25.3124 19.9683C25.5153 18.459 25.5153 16.5257 25.5153 14.0643V13.9358C25.5153 11.4745 25.5153 9.54117 25.3124 8.03177C25.1044 6.48503 24.6695 5.25782 23.7053 4.29359C22.7411 3.32936 21.5139 2.8945 19.9671 2.68655C18.4577 2.48362 16.5245 2.48363 14.0631 2.48364ZM5.48408 5.4853C6.08298 4.88639 6.89526 4.53968 8.25512 4.35685C9.63922 4.17076 11.4592 4.16897 13.9988 4.16897C16.5385 4.16897 18.3585 4.17076 19.7426 4.35685C21.1024 4.53968 21.9147 4.88639 22.5136 5.4853C23.1125 6.0842 23.4592 6.89648 23.6421 8.25634C23.8281 9.64045 23.8299 11.4604 23.8299 14.0001C23.8299 16.5397 23.8281 18.3597 23.6421 19.7438C23.4592 21.1036 23.1125 21.9159 22.5136 22.5148C21.9147 23.1137 21.1024 23.4604 19.7426 23.6433C18.3585 23.8294 16.5385 23.8312 13.9988 23.8312C11.4592 23.8312 9.63922 23.8294 8.25512 23.6433C6.89526 23.4604 6.08298 23.1137 5.48408 22.5148C4.88517 21.9159 4.53846 21.1036 4.35563 19.7438C4.16954 18.3597 4.16775 16.5397 4.16775 14.0001C4.16775 11.4604 4.16954 9.64045 4.35563 8.25634C4.53846 6.89648 4.88517 6.0842 5.48408 5.4853Z",
    fill: "url(#paint4_linear_5178_10837)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5178_10837",
    x1: 13.998,
    y1: 3.32642,
    x2: 13.998,
    y2: 24.6739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5178_10837",
    x1: 13.9988,
    y1: 2.48364,
    x2: 13.9988,
    y2: 25.5165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5178_10837",
    x1: 13.9988,
    y1: 2.48364,
    x2: 13.9988,
    y2: 25.5165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5178_10837",
    x1: 13.9988,
    y1: 2.48364,
    x2: 13.9988,
    y2: 25.5165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5178_10837",
    x1: 13.9988,
    y1: 2.48364,
    x2: 13.9988,
    y2: 25.5165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics01);
export default __webpack_public_path__ + "static/media/analytics-01.a293de607df08f51bb02857db8e545f0.svg";
export { ForwardRef as ReactComponent };